import { SortOrder } from '@approvalmax/ui/src/components';
import { miscHelpers } from '@approvalmax/utils';
import capitalize from 'lodash/capitalize';
import { parse } from 'query-string';
import { TransactionType } from 'shared/data/wallets/v1';

import { messages } from './TransactionsList.messages';
import { ColumnId, TransactionSort } from './TransactionsList.types';

export const getTransactionTypeText = (type: TransactionType): string => {
    switch (type) {
        case TransactionType.funding:
            return messages.transactionTypeFunding;
        case TransactionType.conversion:
            return messages.transactionTypeConversion;
        case TransactionType.payment:
            return messages.transactionTypePayment;
        default:
            return capitalize(type);
    }
};

export const parseSortValuesFromQuery = (search: string): TransactionSort => {
    const values = parse(search);

    return {
        [ColumnId.Wallet]: miscHelpers.castToEnum(SortOrder, values[ColumnId.Wallet]),
        [ColumnId.CreatedDate]: miscHelpers.castToEnum(SortOrder, values[ColumnId.CreatedDate]),
        [ColumnId.Type]: miscHelpers.castToEnum(SortOrder, values[ColumnId.Type]),
        [ColumnId.Amount]: miscHelpers.castToEnum(SortOrder, values[ColumnId.Amount]),
        [ColumnId.Status]: miscHelpers.castToEnum(SortOrder, values[ColumnId.Status]),
    };
};
